<script setup lang="ts"></script>

<template>
  <li class="text-lg m-6 group relative w-max" role="none">
    <slot />
  </li>
</template>

<style scoped></style>
